export const defaultValue = {
  mallInfoId: null,
  mallCd: '',
  mallNm: '',
};

export const mallType = [
  {
    label: 'Domestic',
    value: 'A',
  },
  {
    label: 'Overseas',
    value: 'B',
  },
];

export const mainMallYn = [
  {
    label: 'Main mall',
    value: 'Y',
  },
  {
    label: 'Not Main Mall',
    value: 'N',
  },
];

export const salesProcessingType = [
  {
    label: 'Forwarding + Selling',
    value: 0,
  },
  {
    label: 'Forwarding',
    value: 1,
  },
];

export const orderSinglePackagingYn = [
  {
    label: 'Impossible',
    value: 'Y',
  },
  {
    label: 'Possible',
    value: 'N',
  },
];
